import ChartCommandResults from './ChartCommandResults'
import type { ChartCommandApplyResults } from '../../screener/aiChat/types'

/**
 * Success ticks duplicate what the assistant already said in prose — show them
 * only when the reply is empty (commands-only turn) or when something failed.
 */
export function chartCommandResultsFooter(
    content: string | undefined,
    results: ChartCommandApplyResults | undefined,
) {
    if (!results || (!results.applied.length && !results.failed.length)) {
        return undefined
    }
    const explained = Boolean(content?.trim())
    if (explained && (!results.failed.length || !results.applied.length)) {
        return undefined
    }
    if (explained) {
        return <ChartCommandResults results={{ applied: [], failed: results.failed }} />
    }
    return <ChartCommandResults results={results} />
}
